<template>
   <div>
        <div v-show='!product.product'>
            <ColourPickerPlaceholders />
        </div>
        <div v-if='show_colour_picker'>
            <div v-show='show_selected_colour_text' class='selected-colour-text'><span class='selected-colour-text-bold'>Colour:</span> {{selected_colour.colour}}</div>
            <div class='colour-picker-container'>
                <div v-for="colour in colours" :key='colour'>
                    <a @click.stop='changeColour($event, colour)' :href="`/${product.category_url}${colour.url}`" class="colour-picker-wrapper"  :class="{'selected-colour': selected_colour.colour == colour.colour, 'small': size == 'small'}">
                        <div class="colour-picker" :style="'background-color:'+ colour.swatch"></div>
                    </a>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import ColourPickerPlaceholders from '@/ecom/components/products/single_product/attributes/ColourPickerPlaceholders.vue';

export default {
    components: {ColourPickerPlaceholders},
    emits: ['colourClickedListener'],
    props:{
        show_selected_colour_text:{
            default: false
        },
        size:{
            default: 'large'
        },
        product: {
            default: {}
        },
        page_builder_mode: {
            default: false
        },
        redirect_on_click:{
            default: true
        }
    },
    data(){
        return{
            colours:[
            ],
            selected_colour: {
                id: 0,
                colour : '',
                swatch: ''
            },
            show_colour_picker: false
        }
    },
    methods:{
        async changeColour(e, selected_colour){
              if(e.ctrlKey) {
                return;
            }
            else {
                e.preventDefault();                

                if(!this.page_builder_mode && this.redirect_on_click){
                    this.$router.push(`/${this.product.category_url}${selected_colour.url}`); 
                }

                this.$emit('colourClickedListener', selected_colour.code, selected_colour.url);
             
            }
        },
        setColours(){
             if(typeof this.product.variants.colours !== 'undefined'){
                if(this.product.variants.colours != null){
                    this.colours = this.product.variants.colours;
                    this.mapColours(); //TEMP until do proper colour mapping
                    this.selected_colour = this.product.variants.colours[0];
                    this.show_colour_picker = true;
                }
            }
            else{
                this.show_colour_picker = false;
            }
        },
        mapColours(){  //TEMP until do proper colour mapping
            for (let i = 0; i < this.colours.length; i++) {
                let swatch = '';

                switch(this.colours[i].colour.toLowerCase()){
                    case 'white':
                        swatch = "#f8f9fa";
                        break;
                    case 'black':
                        swatch = "#343a40";
                        break;
                    case 'red':
                        swatch = "#d83131";
                        break;
                    case 'pink':
                        swatch = "#eea1cd";
                        break;
                    case 'purple':
                        swatch = "#800080";
                        break;
                    case 'navy':
                        swatch = "#3E4772";
                        break;
                    case 'green':
                        swatch = "#6e8b3d";
                        break;
                    case 'emerald green':
                        swatch = "#1E5447";
                        break;
                    case 'brown':
                    case 'chocolate':
                        swatch = "#633200";
                        break;
                    case 'blue':
                        swatch = "#005b96";
                        break;
                    case 'cream':
                        swatch = "#eae8e0";
                        break;
                    default:
                        swatch = this.colours[i].colour;
                        break;
                }
                this.colours[i].swatch = swatch;
            }
        }
    },
    mounted(){
        if(typeof this.product.variants !== 'undefined'){
            this.setColours();
        }
    },
    watch:{
        'product' : function(){
            this.show_colour_picker = false;
            if(typeof this.product.variants !== 'undefined'){
                // this.colours = [];
                this.setColours();
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.selected-colour-text{
    margin-bottom: 10px;
    font-size: 0.95rem;
    color: var(--black);
}

.colour-picker-container{
    display: flex;
    gap: 8px;
    align-items: center;
}

.colour-picker-wrapper {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.small {
  width: 20px;
  height: 20px;
}

.colour-picker {
    border-radius: 50%;
    width: 80%;
    height: 80%;
    border: solid 1px #ced4da;
}

.selected-colour{
  border: 2px solid #A2A2A2;
}
.selected-colour-text-bold{
    font-weight: 600;
}
</style>